var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckCircleWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1ZM21.6272 12.0818C22.1243 11.5847 22.1243 10.7789 21.6272 10.2819C21.1302 9.78483 20.3243 9.78483 19.8273 10.2819L13.0909 17.0183L10.1727 14.1C9.67565 13.603 8.8698 13.603 8.37277 14.1C7.87574 14.5971 7.87574 15.4029 8.37277 15.9L12.191 19.7181C12.688 20.2152 13.4938 20.2152 13.9909 19.7181L21.6272 12.0818Z",
    fill: "#079455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckCircleWhiteIcon);
export default __webpack_public_path__ + "static/media/green-check-circle-white-icon.6028280ad1080f8dcf3218c63ad9dee7.svg";
export { ForwardRef as ReactComponent };